import cx from 'classnames';
import store from '~/javascripts/store.js';
import t from '~/javascripts/utils/translation';
import { observer } from 'mobx-react';
import { useRef } from 'react';

const Button = observer(({ classes, id, text, onClick }) => {
  const submitButton = useRef(null);

  const handleClick = (event) => {
    event.preventDefault();

    if (!window.preventDisableButton) {
      store.donateForm.disableFormSubmit = true;
    }
    submitButton.current.blur();

    onClick();
  };

  const shouldDisplayDisclaimerText = () => {
    if (
      store.donateForm.step == 'payment' &&
      store.donateForm.isMycwSubscription &&
      (store.donateForm.paymentTab != 'stripe' || isLastStripeStep())
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isLastStripeStep = () =>
    store.donateForm.paymentTab == 'stripe' &&
    store.donateForm.creditCardStep == '2';

  return (
    <>
      <button
        className={cx(
          'w-full button flex items-center justify-center',
          classes
        )}
        disabled={store.donateForm.disableFormSubmit}
        id={id || 'donate-button'}
        onClick={handleClick}
        ref={submitButton}
        type='submit'
      >
        {store.donateForm.disableFormSubmit && (
          <i className='cw-icon-loop cw-icon-spin mr-1' />
        )}
        {text}
      </button>
      {shouldDisplayDisclaimerText() && (
        <p
          className='h80 text-grey-60 mt-2'
          dangerouslySetInnerHTML={{
            __html: t('views.donate_form.mycw_subscription_disclaimer'),
          }}
        />
      )}
    </>
  );
});

export default Button;
